module.exports = __webpack_public_path__ + "assets/images/pages/workshops/section-2-right.png?f2cda797";